import cx from 'clsx'
import Image from 'next/image'
import React from 'react'

import s from './styles.module.scss'

type ServiceCardProps = {
  title: string
  text: string
  tagLabel: string
  img: {
    alt: string
    src: string
  }
  className?: string
}

export const ServiceCard = ({
  title,
  text,
  tagLabel,
  img,
  className,
}: ServiceCardProps) => {
  return (
    <li className={cx(s.card, className)}>
      <div className={s.cardContent}>
        <p className={s.cardTitle}>{title}</p>
        <p className={s.cardSubtitle}>{text}</p>
        <p className={s.cardTag}>
          <span>{tagLabel}</span>
        </p>
      </div>

      <div className={s.cardImage}>
        <Image src={img.src} alt={img.alt} width={110} height={110} />
      </div>
    </li>
  )
}
